import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconSortAscending from './icon-sort-ascending.vue';

const IconSortAscending = Object.assign(_IconSortAscending, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconSortAscending.name, _IconSortAscending);
  }
});

export default IconSortAscending;
